import { Routes } from '@angular/router';

/* BASE */
import { NotFoundComponent } from '../base/components/pages/not-found/not-found.component';
import { ErrorComponent } from '../base/components/pages/error/error.component';
import { SessionComponent } from '../base/components/pages/session/session.component';
import { MaintenanceComponent } from '../base/components/pages/maintenance/maintenance.component';

/* PROJECT */
import { HomeComponent } from '../project/components/home/home.component';

const appRoutes: Routes = [
    /* PROJECT */
    { path: '', component: HomeComponent },
    /* BASE */
    { path: 'error', component: ErrorComponent },
    { path: 'session', component: SessionComponent },
    { path: 'maintenance', component: MaintenanceComponent },
    { path: '**', component: NotFoundComponent },
];

export default appRoutes;
